import React from "react";
import SvgIconDPC from "./dpc-svg-icon";
import NavigaIcon from "../assets/naviga.svg";

export default class DpcSidebar extends React.Component {

    constructor(props) {
        super(props);
        this.linkList = (
            <ul className="link-list">
                {
                    Array.isArray(this.props.menuItems) && this.props.menuItems.filter(item => item && item.title && item.title.toLowerCase() !== 'homepage').sort((a,b) => {
                        return a.weight > b.weight ? 1 : -1;
                    }).map((item, i) =>
                        <li>
                            <div className="a-link-and-button-collapse">
                                <a className={`list-item ${item.active ? "active" : ""}`}
                                   href={item.link ? item.link : "/#"}>
                                    <span>{item.title}</span>
                                </a>
                                {
                                    item.children.length > 0 && (
                                        <button type="button" className="btn btn-icon right-icon"
                                                title="Espandi menu di navigazione"
                                                data-toggle="collapse"
                                                data-target={`#collapse_sidebar_lvl2_${i}`}
                                                aria-controls={`collapse_sidebar_lvl2_${i}`}
                                                aria-expanded={item.active ? "true" : "false"}>
                                            <SvgIconDPC name='expand'/>
                                        </button>
                                    )
                                }
                            </div>
                            {
                                Array.isArray(item.children) && item.children.length > 0 && (
                                    <ul className={`link-sublist collapse ${item.active ? "show" : ""}`}
                                        id={`collapse_sidebar_lvl2_${i}`}>
                                        {
                                            item.children.sort((a,b) => {
                                                return a.weight > b.weight ? 1 : -1;
                                            }).map((child, j) =>
                                                <li>
                                                    {
                                                        Array.isArray(child.children) && child.children.length > 0 ? (
                                                            <>
                                                                <div className="a-link-and-button-collapse">
                                                                    <a className={`list-item ${child.active ? "active" : ""}`}
                                                                       href={child.link ? child.link : "/#"}>
                                                                        <span>{child.title}</span>
                                                                    </a>
                                                                    <button type="button" className="btn btn-icon right-icon"
                                                                            title="Espandi menu di navigazione"
                                                                            data-toggle="collapse"
                                                                            data-target={`#collapse_sidebar_lvl3_${j}`}
                                                                            aria-controls={`collapse_sidebar_lvl3_${j}`}
                                                                            aria-expanded={child.active ? "true" : "false"}>
                                                                        <SvgIconDPC name='expand'/>
                                                                    </button>
                                                                </div>
                                                                <ul className={`link-sublist collapse ${child.active ? "show" : ""}`}
                                                                    id={`collapse_sidebar_lvl3_${j}`}>
                                                                    {
                                                                        child.children.sort((a,b) => {
                                                                            return a.weight > b.weight ? 1 : -1;
                                                                        }).map((grandchild, k) =>
                                                                            <li>
                                                                                {
                                                                                    grandchild.children.length > 0 ? (
                                                                                        <>
                                                                                            <div className="a-link-and-button-collapse">
                                                                                                <a className={`list-item ${grandchild.active ? "active" : ""}`}
                                                                                                   href={grandchild.link ? grandchild.link : "/#"}>
                                                                                                    <span>{grandchild.title}</span>
                                                                                                </a>
                                                                                                <button type="button" className="btn btn-icon right-icon"
                                                                                                        title="Espandi menu di navigazione"
                                                                                                        data-toggle="collapse"
                                                                                                        data-target={`#collapse_sidebar_lvl4_${k}`}
                                                                                                        aria-controls={`collapse_sidebar_lvl4_${k}`}
                                                                                                        aria-expanded={grandchild.active ? "true" : "false"}>
                                                                                                    <SvgIconDPC name='expand'/>
                                                                                                </button>
                                                                                            </div>
                                                                                            <ul className={`link-sublist collapse ${grandchild.active ? "show" : ""}`}
                                                                                                id={`collapse_sidebar_lvl4_${k}`}>
                                                                                                {
                                                                                                    grandchild.children.sort((a,b) => {
                                                                                                        return a.weight > b.weight ? 1 : -1;
                                                                                                    }).map(greatgrandchild =>
                                                                                                        <li>
                                                                                                            <a className={`list-item ${greatgrandchild.active ? "active" : ""}`}
                                                                                                               href={greatgrandchild.link ? greatgrandchild.link : '/#'}>
                                                                                                                <span>{greatgrandchild.title}</span>
                                                                                                            </a>
                                                                                                        </li>
                                                                                                    )
                                                                                                }
                                                                                            </ul>
                                                                                        </>
                                                                                    ) : (
                                                                                        <a className={`list-item ${grandchild.active ? "active" : ""}`}
                                                                                           href={grandchild.link ? grandchild.link : '/#'}>
                                                                                            <span>{grandchild.title}</span>
                                                                                        </a>
                                                                                    )
                                                                                }
                                                                            </li>
                                                                        )
                                                                    }
                                                                </ul>
                                                            </>
                                                        ) : (
                                                            <a className={`list-item ${child.active ? "active" : ""}`}
                                                               href={child.link ? child.link : '/#'}>
                                                                <span>{child.title}</span>
                                                            </a>
                                                        )
                                                    }
                                                </li>
                                            )
                                        }
                                    </ul>
                                )
                            }
                        </li>
                    )
                }
            </ul>
        );
    }

    render() {
        return (
            <aside aria-label="menu laterale">
                <div className="sidebar-wrapper">
                    <div className="sidebar-linklist-wrapper">
                        <div className="link-list-wrapper">
                            <nav className={this.props.isPortale ? "navbar navbar-expand-xl has-megamenu" : ""} aria-label="Menu laterale">
                                {
                                    this.props.isPortale ?
                                        <>
                                            <span id="navSubDescr">Naviga</span>
                                            <button className="custom-navbar-toggler" type="button" aria-controls="navSub"
                                                    aria-expanded="false" aria-describedby="navSubDescr" data-target="#navSub">
                                                <NavigaIcon/>
                                            </button>
                                            <div className="navbar-collapsable" id="navSub">
                                                <div className="menu-wrapper">
                                                    <div className="close-div">
                                                        <button className="btn close-menu" type="button">
                                                            <SvgIconDPC name='close-circle'/>
                                                        </button>
                                                    </div>
                                                    {this.linkList}
                                                </div>
                                            </div>
                                        </>
                                    : this.linkList
                                }
                            </nav>
                        </div>
                    </div>
                </div>
            </aside>
        );
    }
}
